import React from 'react';
import {connect} from "react-redux";
import {
  SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_FEATURES
} from "../../../../../constants";
import {setSQFTActiveButton, setSQFTMenuOpened, setSQFTPopup} from "../../../../../../../actions/sqftMenuFunctions";
import {FormattedMessage} from "react-intl";
import SqftOptionsHandles from "./toolHandles/SqftOptionsHandles";
import workspace from "../../../../canvas/core/workspace";
import {closeSQFTPopup} from "../../../../canvas/core/controls/resourseCanas";
import SqftOptionsHandlesContent from "./toolHandles/SqftOptionsHandlesContent";
import workspaceControllers from "../../../../canvas/store/workspaceControllers";

const SqftNavigationHandles = (props) => {
  const {setSQFTActiveButton, setSQFTMenuOpened} = props;
  const {menuOpened, setSQFTPopup} = props;
  const expanded = menuOpened === SQFT_FEATURES.top_handle || menuOpened === SQFT_FEATURES.bottom_handle || menuOpened === SQFT_FEATURES.handle

  const popUpContent = () => {
    return <SqftOptionsHandlesContent handlePartId={menuOpened}/>
  }

  const itemClickCallback = () => {
    setSQFTPopup(
      {
        title: workspace.intl.formatMessage({id: "sqft.popup.title.applyHandlesTo"}),
        content: popUpContent(),
        isOpened: true,
        confirmCallback: () => {
          workspaceControllers.handles.generateHandles();
          closeSQFTPopup();
        },
        confirmText: workspace.intl.formatMessage({id: "sqft.popup.button.generate"}),
        cancelCallback: closeSQFTPopup,////closePopup,
        cancelText: workspace.intl.formatMessage({id: "sqft.popup.button.cancel"}),
      }
    );
  }

  const handleClose = () => {
    setSQFTMenuOpened(SIDEBAR_NAVIGATION_BUTTONS.move);
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
  }

  return (
    <div className={"content side-level2" + (expanded ? " expanded" : "")}>
      <div className="content-inner">
        <div className="summary-main-title">
          <div className="summary-main-text">
            <FormattedMessage id="sqft.navigation.submenu.handlesTitle"/>
          </div>
          <button className="button--close"
                  onClick={handleClose}
          />
        </div>
        <div className="lightbox-scroll no-padding">
          <div className={"lightbox-options-wrapper"}>
            {
              <SqftOptionsHandles partId={menuOpened}
                               //partIds={[SQFT_FEATURES.top_handle, SQFT_FEATURES.bottom_handle]}
                               itemClickCallback={(feature) => {
                                 itemClickCallback(feature)
                               }}
                />
            }
          </div>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened,
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton,
  setSQFTPopup
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavigationHandles);
